<script>
	// From Lucide
	import { Check } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Check class={iconClass} />
